import type { IApplicationState } from '../../types/store';

export function selectedRoadsSelector(state: IApplicationState): number[] {
  return state.roads.selectedRoads;
}
